import { FC } from 'react'
import { Row } from '../../core/Components'
import { getSampleCategoryColor } from '../../platform/color'
import { Spinner } from '../../platform/explore/common/utils'
import Badge from '../common/Badge'
import VisualizerContainer from '../common/VisualizerContainer'
import VisualizerWithOverlay from '../common/VisualizerWithOverlay'

interface SampleVisualizerProps {
  audio: HTMLAudioElement
  audioBuffer: AudioBuffer
  instrument: string
  tempo?: number
  originalKey: string
  timesUsed?: number | 'loading'
}

const SampleVisualizer: FC<SampleVisualizerProps> = ({
  audio,
  audioBuffer,
  instrument,
  tempo,
  originalKey,
  timesUsed
}) => {
  const color = getSampleCategoryColor(instrument)
  return (
    <VisualizerContainer>
      <Row css={{ marginBottom: '8px', justifyContent: 'space-between' }}>
        <Badge>{`Sample / ${instrument}`}</Badge>
        <Row>
          {tempo && <Badge css={{ marginRight: '8px' }}>{`BPM: ${tempo}`}</Badge>}
          <Badge>{`Key: ${originalKey}`}</Badge>
        </Row>
      </Row>
      <VisualizerWithOverlay
        audio={audio}
        audioBuffer={audioBuffer}
        options={{ color, resolution: 4, segmentSpacing: 1, segmentWidth: 1.5 }}
      />
      <Row css={{ marginTop: '8px', justifyContent: 'end', height: '18px' }}>
        {timesUsed === undefined ? null : (
          <Badge>
            {'Times used: '}
            {timesUsed !== 'loading' ? (
              timesUsed
            ) : (
              <Spinner css={{ width: '10px', height: '10px' }} />
            )}
          </Badge>
        )}
      </Row>
    </VisualizerContainer>
  )
}

export default SampleVisualizer
